<!-- <p-toast></p-toast> -->
<div class="app-verification-container mt-2">
    <p-card styleClass="p-card-shadow">
        <!-- <h5 class="mt-0">Farmer Application Details</h5> -->
        <div class="dashboardTable">
            <!-- <p-toolbar styleClass="mb-4">
                <ng-template pTemplate="left">
                    <button pButton icon="pi pi-fw pi-plus" label="Add Bank Details" (click)="openNew()"
                        class="p-button-success"></button>
                    <button pButton pRipple  icon="pi pi-trash" class="ml-4 p-button-danger" (click)="deleteSelectedProducts()" [disabled]="!selectedBankAccounts || !selectedBankAccounts.length"></button>
                </ng-template>
                <ng-template pTemplate="right">
                    <p-fileUpload accept=".jpeg,.pdf,.jpg" mode="basic" [maxFileSize]="5000000" label="Import" chooseLabel="Import" class="mr-2 inline-block"></p-fileUpload>
                    <button (click)="menu.toggle($event)" pButton pRipple label="{{'EXPORT'| translate}}" icon="pi pi-upload"
                        class="p-button-help"></button>
                    <button (click)="refreshTable()" pButton pRipple label="{{'REFRESH'| translate}}" icon="pi pi-refresh"
                        class="p-button-info ml-3"></button>
                    <p-menu #menu [popup]="true" [model]="appVerificationItems"></p-menu>
                </ng-template>
            </p-toolbar> -->

            <p-table #appVerificationTable [value]="appVerificationModel" class="dashboard-modified-table" styleClass="p-datatable-gridlines" scrollHeight="500px" [rows]="10" [paginator]="true"
                [globalFilterFields]="[
                'AppUserType',
                'appID',
                'farmerName',
                'ApplicantType',
                'NextLevelID',
                'Scheme_Code', 
                'TargetDays',
                'PendingCompletedDays', 
                'block', 
                'district', 
                'registerationDate_filter', 
                'remarks', 
                'status',
                'Status_Ar', 
                'village', 
                'TotalArea', 
                'PreviousActionDate', 
                'FinYear',
                'AssignedDate',
                'ActionDate',
                'Caste_Description',
                'CompName',
                'CropNames'
                ]"
                responsiveLayout="scroll" [(selection)]="selectedBankAccounts" [rowHover]="true" dataKey="id"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                [showCurrentPageReport]="true" sortMode="multiple" [multiSortMeta]="multiSortMeta" [loading]="loading">
                <ng-template pTemplate="caption">
                    <!-- <div class="flex align-items-center justify-content-between">
                        <h5 class="m-0">{{'FARMER_APPLICATION_FOR_APPROVAL_(FURTHER_ACTION_TAKEN)'| translate}}</h5>
                        <span class="p-input-icon-left">
                            <i class="pi pi-search"></i>
                            <input pInputText type="text"
                                (input)="appVerificationTable.filterGlobal($any($event.target).value, 'contains')"
                                placeholder="{{'SEARCH'| translate}}" />
                        </span>
                    </div> -->
                    <div class="flex align-items-center justify-content-between">
                        <!-- Left side -->
                        <div class="col-5">
                            <label for="">Application Count&nbsp;&nbsp;</label>
                            <p-dropdown 
                                [options]="appCountList" 
                                [(ngModel)]="selectedAppCount" 
                                optionLabel="value" 
                                optionValue="id"
                                (onChange)="onAppCountChange($event)"
                                placeholder="Select App Count"></p-dropdown>
                            <!-- <h5 class="m-0 table-header-text">{{'FARMER_APPLICATION_FOR_APPROVAL_(FURTHER_ACTION_TAKEN)'| translate}}</h5> -->
                        </div>
                        <!-- Middle section for buttons -->
                        <div class="col-3 d-flex  justify-content-between">
                            <button (click)="menu.toggle($event)" pButton pRipple label="" icon="pi pi-download" class="p-button-help mx-1"></button>
                            <button (click)="refreshTable()" pButton pRipple label="" icon="pi pi-refresh" class="p-button-info mx-1"></button>
                            <p-menu #menu [popup]="true" [model]="appVerificationItems"></p-menu>
                        </div>
                        <!-- Right side for search -->
                        <div class="col-5 d-flex align-items-center justify-content-end">
                            <span class="p-input-icon-left">
                                <i class="pi pi-search"></i>
                                <input pInputText type="text" (input)="appVerificationTable.filterGlobal($any($event.target).value, 'contains')" placeholder="{{'SEARCH'| translate}}" />
                            </span>
                        </div>
                    </div>
                </ng-template>
                <ng-template pTemplate="header">
                    <tr>
                        <!-- <th style="width: 3rem">
                            <p-tableHeaderCheckbox></p-tableHeaderCheckbox>

                        </th> -->
                        <th pFrozenColumn>{{'VIEW_APPLICATION' | translate}}</th>
                        <th pSortableColumn="AppUserType">{{'APP_USER_TYPE'| translate}}
                            <p-columnFilter type="text" field="AppUserType" display="menu"></p-columnFilter>
                            <p-sortIcon field="AppUserType"></p-sortIcon>
                        </th>
                        <th>{{'KYC_STATUS'| translate}}</th>
                        <th pSortableColumn="appID">{{'APP_ID'| translate}}.
                            <p-columnFilter type="text" field="appID" display="menu"></p-columnFilter>
                            <p-sortIcon field="appID"></p-sortIcon>
                        </th>
                        <th pSortableColumn="CompName">{{'COMPONENT_NAME'| translate}}.
                            <p-columnFilter type="text" field="CompName" display="menu"></p-columnFilter>
                            <p-sortIcon field="CompName"></p-sortIcon>
                        </th>
                        <th pSortableColumn="CropNames" class="custom-width-col">{{'CROP_NAME'| translate}}.
                            <p-columnFilter type="text" field="CropNames" display="menu"></p-columnFilter>
                            <p-sortIcon field="CropNames"></p-sortIcon>
                        </th>
                        <th pSortableColumn="farmerName">{{'FARMER_NAME'| translate}}
                            <p-columnFilter type="text" field="farmerName" display="menu"></p-columnFilter>
                            <p-sortIcon field="farmerName"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Caste_Description">{{'CASTE'| translate}}
                            <p-columnFilter type="text" field="Caste_Description" display="menu"></p-columnFilter>
                            <p-sortIcon field="Caste_Description"></p-sortIcon>
                        </th>
                        <th pSortableColumn="AssignedDate">{{'ASSIGNED_DATE'| translate}}
                            <p-columnFilter type="text" field="AssignedDate" display="menu"></p-columnFilter>
                            <p-sortIcon field="AssignedDate"></p-sortIcon>
                        </th>
                        <!-- <th pSortableColumn="resubmissionAndRegistrationDate">{{'REGISTRATION_DATE'| translate}}
                            <p-columnFilter type="text" field="registerationDate_filter" display="menu"></p-columnFilter>
                            <p-sortIcon field="resubmissionAndRegistrationDate"></p-sortIcon>
                        </th> -->
                        <th pSortableColumn="PreviousActionDate">{{'RESUBMISSION_DATE'| translate}}
                            <p-columnFilter type="text" field="PreviousActionDate" display="menu"></p-columnFilter>
                            <p-sortIcon field="PreviousActionDate"></p-sortIcon>
                        </th>
                        <th pSortableColumn="ActionDate">{{'ACTION_DATE'| translate}}
                            <p-columnFilter type="text" field="ActionDate" display="menu"></p-columnFilter>
                            <p-sortIcon field="ActionDate"></p-sortIcon>
                        </th>
                        <th pSortableColumn="ApplicantType">{{'APPLICANT_TYPE'| translate}}
                            <p-columnFilter type="text" field="ApplicantType" display="menu"></p-columnFilter>
                            <p-sortIcon field="ApplicantType"></p-sortIcon>
                        </th>
                        <th pSortableColumn="NextLevelID">{{'NEXT_LEVEL_ID'| translate}}
                            <p-columnFilter type="text" field="NextLevelID" display="menu"></p-columnFilter>
                            <p-sortIcon field="NextLevelID"></p-sortIcon>
                        </th>
                        <th pSortableColumn="TotalArea">{{'TOTAL_AREA'| translate}}
                            <p-columnFilter type="text" field="TotalArea" display="menu"></p-columnFilter>
                            <p-sortIcon field="TotalArea"></p-sortIcon>
                        </th>
                        <!-- <th pSortableColumn="Scheme_Code">{{'SCHEMA_CODE'| translate}}
                            <p-columnFilter type="text" field="Scheme_Code" display="menu"></p-columnFilter>
                            <p-sortIcon field="Scheme_Code"></p-sortIcon>
                        </th> -->
                        <th pSortableColumn="TargetDays">{{'TARGET_DAYS'| translate}}
                            <p-columnFilter type="text" field="TargetDays" display="menu"></p-columnFilter>
                            <p-sortIcon field="TargetDays"></p-sortIcon>
                        </th>
                        <th pSortableColumn="PendingCompletedDays">{{'PENDING_COMPLETED_DAYS'| translate}}
                            <p-columnFilter type="text" field="PendingCompletedDays" display="menu"></p-columnFilter>
                            <p-sortIcon field="PendingCompletedDays"></p-sortIcon>
                        </th>
                        <th pSortableColumn="village">{{'VILLAGE'| translate}}
                            <p-columnFilter type="text" field="village" display="menu"></p-columnFilter>
                            <p-sortIcon field="village"></p-sortIcon>
                        </th>
                        <th pSortableColumn="block">{{'BLOCK'| translate}}
                            <p-columnFilter type="text" field="block" display="menu"></p-columnFilter>
                            <p-sortIcon field="block"></p-sortIcon>
                        </th>
                        <th pSortableColumn="district">{{'DISTRICT'| translate}}
                            <p-columnFilter type="text" field="district" display="menu"></p-columnFilter>
                            <p-sortIcon field="district"></p-sortIcon>
                        </th>
                        <th pSortableColumn="status">{{'STATUS'| translate}}
                            <p-columnFilter type="text" field="status" display="menu"></p-columnFilter>
                            <p-sortIcon field="status"></p-sortIcon>
                        </th>
                        <th pSortableColumn="remarks">{{'REMARKS'| translate}}
                            <p-columnFilter type="text" field="remarks" display="menu"></p-columnFilter>
                            <p-sortIcon field="remarks"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Status_Ar">{{'CURRENT_STATUS'| translate}}
                            <p-columnFilter type="text" field="Status_Ar" display="menu"></p-columnFilter>
                            <p-sortIcon field="Status_Ar"></p-sortIcon>
                        </th>
                        <th pSortableColumn="FinYear">{{'FINANCIAL_YEAR'| translate}}
                            <p-columnFilter type="text" field="FinYear" display="menu"></p-columnFilter>
                            <p-sortIcon field="FinYear"></p-sortIcon>
                        </th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-product>
                    <tr [ngStyle]="{'color': 'black', 'background-color': rowBackgroundColor(product)}">
                        <td pFrozenColumn>
                            <button *ngIf="product?.IsAadharVerified == 1" pButton pRipple pTooltip="view application" icon="pi pi-file"
                            class="p-button-rounded p-button-accent p-button-secondary p-button-sm"
                                (click)="printForm(product.appID, product.Status_Ar)"></button>

                            <!-- <button pButton pRipple pTooltip="view application" icon="pi pi-file"
                                class="p-button-rounded p-button-accent mr-1 btnSize"
                                (click)="printForm(product.appID,miDetailsByAppId[0].VendorId,miDetailsByAppId[0].ProgId,miDetailsByAppId[0].User_ID,miDetailsByAppId[0].AutoId,product.Status_Ar)"></button> -->
                        </td>
                        <td>{{product?.IsAadharVerified == 1 ? 'Verified' : 'Not Verified'}}</td>
                        <td>{{product.AppUserType}}</td>
                        <td>{{product.appID}}</td>
                        <td>{{product?.CompName}}</td>
                        <td class="custom-width-col">{{product?.CropNames}}</td>
                        <td>{{product.farmerName}}</td>
                        <td>{{product?.Caste_Description}}</td>
                        <td>{{product.AssignedDate | date:'medium'}}</td>
                        <!-- <td>{{product.registerationDate | date:'medium'}}</td> -->
                        <td>{{product.PreviousActionDate | date:'medium'}}</td>
                        <td>{{product.ActionDate | date:'medium'}}</td>
                        <td>{{product.ApplicantType}}</td>
                        <td>{{product.NextLevelID}}</td>
                        <td>{{product.TotalArea}}</td>
                        <!-- <td>{{product.Scheme_Code}}</td> -->
                        <td>{{product.TargetDays}}</td>
                        <td>{{product.PendingCompletedDays}}</td>
                        <td>{{product.village}}</td>
                        <td>{{product.block}}</td>
                        <td>{{product.district}}</td>
                        <td>{{product.status}}</td>
                        <td>{{product.remarks}}</td>
                        <td>{{product.Status_Ar}}</td>
                        <td>{{product.FinYear}}</td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="summary">
                    <div class="flex  justify-content-between flex-column ">
                        <p>{{'IN_TOTAL_THERE_ARE'| translate}} {{appVerificationModel ? appVerificationModel.length : 0 }} {{'VERIFICATION_APPLICATIONS_ADDED'| translate}}.
                        </p>
                        <div class="flex  justify-content-between flex-column "> 
                            <div class="flex"><div style="background-color:#ff8080 ; width: 20px; height: 20px;border-radius: 5px;margin-bottom: 2px;margin-right: 4px;"></div>{{'PENDING_MORE_THAN_TWO_DAYS'| translate}}</div>
                            <div class="flex"><div style="background-color:#ffc966 ; width: 20px; height: 20px;border-radius: 5px;margin-bottom: 2px;margin-right: 4px;"></div>{{'PENDING_BY_ONE_DAY'| translate}}</div>
                            <div class="flex"><div style="background-color:#99e699 ; width: 20px; height: 20px;border-radius: 5px;margin-bottom: 2px;margin-right: 4px;"></div>{{'APROVED_ON_TIME'| translate}}</div>
                            <div class="flex"><div style="background-color:#ffb3b3 ; width: 20px; height: 20px;border-radius: 5px;margin-bottom: 2px;margin-right: 4px;"></div>{{'DELAYED_APPROVED'| translate}}</div>
                        </div>
                    </div>
                </ng-template>
            </p-table>
        </div>
    </p-card>
</div>

<p-confirmDialog [style]="{width: '400px'}"></p-confirmDialog>